import Container from './components/Container/Container';
import './css/App.css';

const App: React.FunctionComponent = () => {
  return (
    <div className="App">
      <Container />
    </div>
  );
}

export default App;
